const bill = {
    getlist: '/Cafebazar/getlist',
    import: '/Cafebazar/import',
    exportExcel:'Cafebazar/excel',
    zarinPalgetlist: '/Zarinpal/getlist',
    zarinPalimport: '/Zarinpal/import',
    zarinPalexportExcel:'Zarinpal/excel',

}
export default bill
